import { menuData } from "../pages/App-Configuration/App-Configuration";

export const partnerKey = "b6fd08d878c60deaa10ff94464aad7a17fc675f6";

export const formatConfigData = (data, warahouses, registers, allUsers) => {
  const newData = [];

  data.forEach((e) => {
    if (
      typeof e.value === "string" ||
      typeof e.value === "number" ||
      typeof e.value === "undefined"
    ) {
      e.isJSON = false;
    } else {
      e.value = JSON.stringify(e.value);
      e.isJSON = true;
    }

    if (e.level === "Warehouse") {
      let id = e.level_id;
      const isFound = warahouses.find((e) => e.warehouseID === id);
      if (isFound) {
        e.levelIdName = isFound.name;
      } else {
        e.levelIdName = e.level_id;
      }
    } else if (e.level === "Pos") {
      let id = parseInt(e.level_id, 10);
      const isFound = registers.find((e) => e.pointOfSaleId === id);
      if (isFound) {
        e.levelIdName = isFound.name;
      } else {
        e.levelIdName = e.level_id;
      }
    } else if (e.level === "User") {
      let id = parseInt(e.level_id, 10);
      const isFound = allUsers.find((e) => e.userID === id);
      if (isFound) {
        e.levelIdName = isFound.userName;
      } else {
        e.levelIdName = e.level_id;
      }
    } else if (e.level === "Company") {
      e.levelIdName = e.level_id;
    } else {
      e.levelIdName = e.level_id;
    }

    newData.push(e);
  });

  return newData;
};

export const formatParameters = (parameters) => {
  const newData = [];

  for (const [key, value] of Object.entries(parameters)) {
    if (!filterData(key) && value !== "") {
      newData.push({ name: key, value });
    }
  }

  return newData;
};

const filterData = (key) => {
  let result = false;
  if (
    key === "additionalModules" ||
    key === "account_links" ||
    key === "price_decimals" ||
    key === "default_currency" ||
    key === "date_installed" ||
    key === "invoice_algorithm_version" ||
    key === "locale_uses_price_with_tax" ||
    key === "invoice_waybills_show_price_with_tax" ||
    key === "languages" ||
    key === "langs" ||
    key === "product_description_eng_enabled" ||
    key === "product_description_rus_enabled" ||
    key === "product_description_fin_enabled" ||
    key === "product_longdescription_eng_enabled" ||
    key === "product_longdescription_rus_enabled" ||
    key === "product_longdescription_fin_enabled" ||
    key.startsWith("tablesize_")
  ) {
    result = true;
  }

  return result;
};

export const compareAndMergeApplications = (applications) => {
  const dist = {};
  const items = [...menuData];

  for (let i in menuData) {
    dist[menuData[i].value] = menuData[i];
  }

  for (let j in applications) {
    if (dist[applications[j].value] === undefined) {
      items.push(applications[j]);
    }
  }

  return items;
};

export const composeLanguages = (allLanguages, activeLanges, country) => {
  const items = [];

  const dist = {};

  for (let i in activeLanges) {
    dist[activeLanges[i].name] = activeLanges[i];
  }

  for (let j in allLanguages) {
    if (allLanguages[j].countries.length) {
      if (allLanguages[j].countries.includes(country)) {
        if (dist[allLanguages[j].name] === undefined) {
          items.push({ ...allLanguages[j], activeStatus: "No" });
        } else {
          items.push({ ...allLanguages[j], activeStatus: "Yes" });
        }
      } else {
        items.push({
          ...allLanguages[j],
          activeStatus: "Not available in this country",
        });
      }
    } else {
      if (dist[allLanguages[j].name] === undefined) {
        items.push({ ...allLanguages[j], activeStatus: "No" });
      } else {
        items.push({ ...allLanguages[j], activeStatus: "Yes" });
      }
    }
  }

  return items;
};
